import { EditForm } from "./CustomerInfoContainer";

export const formConfig: {
  label: string;
  field: keyof EditForm;
}[] = [{
  label: "Role",
  field: "role"
}, {
  label: "Label or Manager",
  field: "labelOrManager"
}, {
  label: "Main Contact",
  field: "fullName"
}, {
  label: "Email",
  field: "email"
}, {
  label: "Phone",
  field: "phone"
}, {
  label: "Address",
  field: "address"
}, {
  label: "Country",
  field: "country"
}, {
  label: "Initial Password",
  field: "initialPassword"
}, {
  label: "Lead source",
  field: "leadSource"
}, {
  label: "Notes",
  field: "notes"
}];